import React from "react";
import { questions } from "../types";

interface EndScreenProps {
  submittedText: string;
  onRestart: () => void;
  marksAndFeedback: Record<number, { marks_awarded: number; feedback: string }>;
  submitError: string | null;
  answers: Record<number, string>;
}

const End: React.FC<EndScreenProps> = ({
  submittedText,
  onRestart,
  submitError,
  marksAndFeedback,
  answers,
}) => {
  return (
    <div className="Screen ActiveScreen">
      <h1 className="Title">Submission Received</h1>
      <p className="Description">
        Your content and activity log has been successfully submitted. Below is
        what you submitted:
      </p>

      {submitError && (
        <p
          className="error-message"
          style={{ marginBottom: "1rem", color: "red" }}
        >
          {submitError}
        </p>
      )}

      <div className="SubmittedContent">
        {questions.map((question) => {
          const answer = answers[question.questionNumber] || "";
          const result = marksAndFeedback[question.questionNumber];
          const marksAwarded = result?.marks_awarded ?? 0;
          const feedback = result?.feedback ?? "No feedback provided.";

          return (
            <div
              key={question.questionNumber}
              className="question-block"
              style={{
                marginBottom: "2rem",
                border: "1px solid #ddd",
                padding: "1rem",
                borderRadius: "6px",
              }}
            >
              <h2 style={{ marginBottom: "0.5rem" }}>
                Question {question.questionNumber} (Max {question.maximumMarks}{" "}
                marks)
              </h2>
              <p style={{ marginBottom: "1rem" }}>{question.questionText}</p>

              <div className="answer-section" style={{ marginBottom: "1rem" }}>
                <p style={{ fontWeight: "bold", marginBottom: "0.25rem" }}>
                  Your Answer:
                </p>
                <textarea
                  className="answer-input"
                  value={answer}
                  readOnly
                  rows={3}
                  style={{
                    width: "100%",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #ccc",
                    padding: "0.5rem",
                    resize: "none",
                  }}
                />
              </div>

              <div className="marks-section" style={{ marginBottom: "1rem" }}>
                <p style={{ fontWeight: "bold" }}>
                  Marks Awarded:{" "}
                  <span style={{ fontWeight: "normal" }}>
                    {marksAwarded} / {question.maximumMarks}
                  </span>
                </p>
              </div>

              <div
                className="feedback-section"
                style={{ marginBottom: "1rem" }}
              >
                <p style={{ fontWeight: "bold", marginBottom: "0.25rem" }}>
                  Feedback:
                </p>
                <p
                  style={{
                    backgroundColor: "#fffbe6",
                    border: "1px solid #ffe58f",
                    padding: "0.5rem",
                    borderRadius: "4px",
                  }}
                >
                  {feedback}
                </p>
              </div>

              <div className="mark-scheme-section">
                <p style={{ fontWeight: "bold", marginBottom: "0.25rem" }}>
                  Mark Scheme:
                </p>
                <ul style={{ paddingLeft: "1.25rem", marginTop: "0.5rem" }}>
                  {question.markScheme.map((point, idx) => (
                    <li key={idx} style={{ marginBottom: "0.25rem" }}>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ marginTop: "2rem", textAlign: "center" }}>
        <button className="Button" onClick={onRestart}>
          Restart
        </button>
      </div>
    </div>
  );
};

export default End;
